var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9075 26.6667C26.9075 31.5573 24.2482 35.8357 20.2872 38.1496L16.7206 34.6148C15.8655 33.7674 14.6964 33.3316 13.4854 33.3316C17.1847 33.3178 20.186 30.3398 20.186 26.6667C20.186 22.9935 17.1917 20.019 13.4924 20.0017H13.5587C14.7174 20.019 15.8376 19.5971 16.6542 18.7843L20.2907 15.1803C24.2552 17.4976 26.911 21.776 26.911 26.6632L26.9075 26.6667Z",
    fill: "#458FE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7171 34.6148L20.2837 38.1496C18.2735 39.329 15.9283 40.0035 13.4226 39.9965C6.26839 39.9827 0.297218 34.3 0.0110482 27.2131C-0.29606 19.6005 5.83913 13.3333 13.454 13.3333C15.9493 13.3333 18.284 14.0043 20.2837 15.1803L16.6473 18.7843C15.8271 19.5971 14.7069 20.0156 13.5483 20.0017C13.5273 20.0017 13.5064 20.0017 13.4854 20.0017C10.0689 19.9844 7.21414 22.4263 6.7814 25.7882C6.25443 29.8625 9.44417 33.3351 13.4505 33.3351C13.4575 33.3351 13.461 33.3351 13.468 33.3351C14.6825 33.3351 15.8551 33.7674 16.7136 34.6182L16.7171 34.6148Z",
    fill: "#AFE4FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2122 28.5517L31.6607 40C29.0328 37.3956 29.0328 33.176 31.6607 30.5716L40.3574 21.9524L43.2122 24.7817C44.2626 25.8227 44.2626 27.5106 43.2122 28.5517Z",
    fill: "#458FE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72556 6.66494V15.1146C2.70872 17.4215 0.00057858 21.7311 0.00057858 26.6667V0C3.71729 0 6.72556 2.98487 6.72556 6.66494Z",
    fill: "#AFE4FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2122 28.5517L40.3574 31.3809L31.6607 22.7618C29.0328 20.1574 29.0328 15.9377 31.6607 13.3333L43.2122 24.7817C44.2626 25.8227 44.2626 27.5106 43.2122 28.5517Z",
    fill: "#AFE4FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5027 34.2101C39.0802 32.6468 39.0802 30.115 37.5027 28.5517L40.3574 31.3809L37.5027 34.2101Z",
    fill: "#AFE4FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small-logo.7d3faaaeef60175a3cfdbbdd6241b27a.svg";
export { ForwardRef as ReactComponent };